import { contractorApi } from '@/lib/api'

import { ExternalContractor } from '../types'

export function getCurrentContractor() {
  return contractorApi.get<ExternalContractor>(`/v1/my/contractor`)
}
